/*jshint esversion: 6 */
import { localStorage } from '../config/ips';
const localStorageName = localStorage;

/**
 * usage: 
 * clearLocalStorage();
 */
const clearLocalStorage = () => {
  console.log(`----- clearLocalStorage`);
  window.localStorage.setItem(localStorageName, '');
};

/**
 * usage: 
    updateLocalStorageFields({
      token:  rst.token,
      name:   rst.name,
      uuid:   rst.uuid,
      admin:  rst.admin,
      theme:  rst.theme,
      lang:   rst.lang,
      adminMode: rst.adminMode,
    });
 */
const updateLocalStorageFields = (data) => {
  console.log(`----- updateLocalStorageFields: `, data);
  if (Object.keys(data).length === 0) return null;
  const localStorageString = window.localStorage.getItem(localStorageName);
  let localStorage = {};
  if (localStorageString && localStorageString !== '[object Object]') {
    localStorage = JSON.parse(localStorageString);
  }
  Object.keys(data).map(key => {
    localStorage[key] = data[key];
    return null;
  });
  window.localStorage.setItem(localStorageName, JSON.stringify(localStorage));
};


/**
 * 
 * usage:
    const ls = getLocalStorageAllFields();
    const token = ls.token;
 */
const getLocalStorageAllFields = () => {
  console.log(`----- getLocalStorageAllFields`);
  const localStorageString = window.localStorage.getItem(localStorageName);
  if (localStorageString && localStorageString !== '[object Object]') {
    const localStorage = JSON.parse(localStorageString);
    return localStorage;
  }
  return {};
};


/**
 * 
 * usage:
    const token = getLocalStorageFieldWithFieldName('token');
 */
const getLocalStorageFieldWithFieldName = (fieldName) => {
  console.log(`----- getLocalStorageFieldWithFieldName[${fieldName}]`);
  const localStorage = getLocalStorageAllFields();
  return localStorage[fieldName] || '';
};


export {
  clearLocalStorage,
  updateLocalStorageFields,
  getLocalStorageAllFields,
  getLocalStorageFieldWithFieldName,
};
